var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as moment from 'moment/moment';
/**
 * Log the data
 * @param title log title
 * @param data log data object
 */
var logger = function (title) {
    var data = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        data[_i - 1] = arguments[_i];
    }
    var randomColor = getRandomColor();
    window['console']['log']("\n\n%c =======  " + title + " ======= %c" + moment().format('HH:mm:ss SSS') + " \n", "color:" + randomColor + ";font-size:15", "color:" + getRandomColor() + ";font-size:15");
    window['console']['log']("");
    window['console']['log']("    ", data);
    window['console']['log']("\n =========================================");
};
/**
 * Get random color in hex
 */
var getRandomColor = function () {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};
var updateObject = function (oldObject, updatedProperties) {
    return __assign({}, oldObject, updatedProperties);
};
var getStateSlice = function (state) { return state.toJS()['locale']; };
export default {
    logger: logger,
    getRandomColor: getRandomColor,
    updateObject: updateObject,
    getStateSlice: getStateSlice
};



//////////////////
// WEBPACK FOOTER
// ./src/api/CommonAPI.ts
// module id = 409
// module chunks = 50